(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["free-sample-page"] && !Shopify.designMode) return;
  try {
    
  const freeSampleSuccess = document.querySelector('[data-free-sample-success]');

  if (freeSampleSuccess) {
    const cleanUrl = freeSampleSuccess.dataset.cleanUrl;

    if (cleanUrl) {
      window.history.replaceState(window.history.state, '', cleanUrl);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
